import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useFieldArray } from "react-hook-form";
import classes from "./formFieldSpecsArray.module.css";

export const FormFieldSpecsArray = ({
  name,
  label,
  register,
  disabled,
  validation,
  placeholder__head,
  placeholder__value,
  control,
  getValues,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAdd = () => {
    const allFields = getValues(name);
    const last = allFields?.[allFields.length - 1];

    const canAdd = !last || (last.name?.trim() && last.value?.trim());

    if (canAdd) {
      append({ name: "", value: "" });
    } else {
      return;
    }
  };

  const handleRemove = (index) => remove(index);

  return (
    <motion.div
      className={classes.box}
      layout
      transition={{
        layout: {
          duration: 0.4,
          ease: [0.25, 0.8, 0.25, 1],
        },
      }}
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
    >
      <label className={classes.box__title}>{label}</label>

      <AnimatePresence initial={false}>
        {fields.map((field, index) => (
          <motion.div
            key={field.id}
            className={classes.box__content}
            layout
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            <input
              type="text"
              placeholder={placeholder__head}
              className={classes.box__content__input}
              disabled={disabled}
              {...register(`${name}.${index}.name`, validation)}
            />
            <input
              type="text"
              placeholder={placeholder__value}
              className={classes.box__content__input}
              disabled={disabled}
              {...register(`${name}.${index}.value`, validation)}
            />
            <button
              type="button"
              onClick={() => handleRemove(index)}
              className={classes.box__content__input__delete}
            />
          </motion.div>
        ))}
      </AnimatePresence>

      <button type="button" onClick={handleAdd} className={classes.box__add}>
        + Add
      </button>
    </motion.div>
  );
};
